import _ from 'lodash';
import { applyFilter } from '../filter-like';
import { parseValue } from './price-manager';

function filterMenu(categories, filter) {
  let result = categories;

  if (!_.isEmpty(filter)) {
    result = [];

    // const categoriesIds = applyFilter(
    //   filter,
    //   categories,
    //   (category) =>
    //     `
    //     ${category.name ?? ''}
    //     ${category.description ?? ''}
    //     ${category.type?.name ?? ''}
    //     ${category.option_groups
    //       ?.reduce((acc, og) => acc.concat(og.options ?? []), [])
    //       ?.map(
    //         (o) => `
    //                ${o.name ?? ''}
    //                ${o.hint ?? ''}
    //                `
    //       )}
    //     `
    // ).map((category) => category.id);

    _.cloneDeep(categories).forEach((category) => {
      const items = applyFilter(
        filter,
        category.items,
        (item) =>
          `
          ${category.name ?? ''}
          ${category.description ?? ''}
          ${category.type?.name ?? ''}
          ${category.option_groups
            ?.reduce((acc, og) => acc.concat(og.options ?? []), [])
            ?.map(
              (o) => `
                     ${o.name ?? ''}
                     ${o.hint ?? ''}
                     `
            )}
          ${item.name ?? ''}
          ${item.description ?? ''}
          ${item.hint ?? ''}
          ${item.option_groups
            ?.reduce((acc, og) => acc.concat(og.options ?? []), [])
            ?.map(
              (o) => `
                     ${o.name ?? ''}
                     ${o.hint ?? ''}
                     `
            )}
          ${item.prices?.map(
            (p) => `
                   ${p.hint ?? ''}
                   ${parseValue(p.value) ?? ''}
                   `
          )}
          `
      );

      // if (categoriesIds.includes(category.id)) {
      //   result.push(categories.find((c) => c.id === category.id));
      // } else if (!_.isEmpty(items)) {
      if (!_.isEmpty(items)) {
        const itemsIds = items.map((i) => i.id);
        category.items = items;

        const images = category.images?.filter((i) =>
          itemsIds.includes(i.item.id)
        );
        category.images = _.cloneDeep(images);

        result.push(category);
      }
    });
  }

  const itemsCount = result?.reduce(
    (acc, category) => acc + (category.items?.length ?? 0),
    0
  );

  return [
    result,
    {
      categories: result?.length ?? 0,
      items: itemsCount,
    },
  ];
}

export { filterMenu };
